import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  
baseURL: 'http://localhost:8000/api/v1/',

})

Vue.prototype.$http = axiosIns

export default axiosIns
